import { titleCase } from '../utils/format';

const TONE_MAP = {
  active: 'success',
  completed: 'success',
  approved: 'success',
  ended: 'neutral',
  pending: 'warning',
  cancelled: 'danger',
  failed: 'danger',
  rejected: 'danger',
  draft: 'neutral'
};

export default function StatusBadge({ value }) {
  if (!value) return <span className="badge badge-neutral">—</span>;
  const tone = TONE_MAP[String(value).toLowerCase()] || 'neutral';
  return <span className={`badge badge-${tone}`}>{titleCase(value)}</span>;
}
